"use strict";

var _classCallCheck = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _inherits = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoiseDelay = void 0;

var ValueWithRandom_1 = require("../../../ValueWithRandom");

var NoiseDelay = /*#__PURE__*/function (_ValueWithRandom_1$Va) {
  _inherits(NoiseDelay, _ValueWithRandom_1$Va);

  var _super = _createSuper(NoiseDelay);

  function NoiseDelay() {
    _classCallCheck(this, NoiseDelay);

    return _super.call(this);
  }

  return NoiseDelay;
}(ValueWithRandom_1.ValueWithRandom);

exports.NoiseDelay = NoiseDelay;